export const LOG_TYPE_INVOICE = 'invoice';
export const LOG_TYPE_HOUSEKEEPING = 'housekeeping';
export const LOG_TYPE_MAPPING = Object.freeze({
    [LOG_TYPE_INVOICE]: 'Invoice',
    [LOG_TYPE_HOUSEKEEPING]: 'Housekeeping',
});
